export const browserAndOsDetails = () => {
  var nAgt = navigator.userAgent;
  var browserName;
  var fullVersion;
  var verOffset;
  var spliced;
  var nameOffset;
  var OSName = "Unknown OS";

  if ((verOffset = nAgt.indexOf("Opera")) != -1) {
    fullVersion = nAgt.substring(verOffset + 6);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Opera " + spliced;
  } else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
    fullVersion = nAgt.substring(verOffset + 5);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Microsoft Internet Explorer " + spliced;
  } else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
    fullVersion = nAgt.substring(verOffset + 4);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Microsoft Edge " + spliced;
  } else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
    fullVersion = nAgt.substring(verOffset + 7);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Chrome " + spliced;
  } else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
    fullVersion = nAgt.substring(verOffset + 7);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Safari " + spliced;
  } else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
    fullVersion = nAgt.substring(verOffset + 8);
    spliced = fullVersion.split(" ").slice(0, 1);
    browserName = "Firefox " + spliced;
  } else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
  }

  //os version
  if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
    OSName = "Windows 10";
  if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
    OSName = "Windows Server 2012";
  if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
    OSName = "Windows 8";
  if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
    OSName = "Windows 7";
  if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
    OSName = "Windows Vista";
  if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
    OSName = "Windows XP";
  if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
    OSName = "Windows 2000";
  if (window.navigator.userAgent.indexOf("Mac") != -1) OSName = "Mac/iOS";
  if (window.navigator.userAgent.indexOf("X11") != -1) OSName = "UNIX";
  if (window.navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";

  return [browserName, OSName];
};
